import DOMPurify from 'dompurify'

interface FormData {
  email: string
  subject: string
  description: string
  requestType: string
  impact: string
  allowImpersonation: boolean
  functionalArea: string
  usageContext: string
}

export function sanitizeFormData(data: FormData): FormData {
  return {
    ...data,
    email: data.email.trim().toLowerCase(),
    subject: DOMPurify.sanitize(data.subject.trim()),
    description: DOMPurify.sanitize(data.description.trim()),
    requestType: DOMPurify.sanitize(data.requestType),
    impact: DOMPurify.sanitize(data.impact),
    functionalArea: DOMPurify.sanitize(data.functionalArea),
    usageContext: DOMPurify.sanitize(data.usageContext),
    allowImpersonation: !!data.allowImpersonation
  }
}